// extracted by mini-css-extract-plugin
export var md = "_5q-4";
export var sm = "_5q-3";
export var text = "_5q-5";
export var toggleInput = "_5q-0";
export var toggleSwitch = "_5q-1";
export var xs = "_5q-2";